(function () {
  const header = document.querySelector("header");
  const mainEl = document.querySelector("[data-template]");
  const template = mainEl ? mainEl.getAttribute("data-template") : "";
  const isHomepage = template === "index" || window.location.pathname === "/" || window.location.pathname === "/index";

  if (header) {
    if (isHomepage) {
      const handleScroll = () => {
        if (window.scrollY > 50) {
          header.classList.add("scrolled");
        } else {
          header.classList.remove("scrolled");
        }
      };

      // Run once initially
      handleScroll();

      // Add scroll listener
      window.addEventListener("scroll", handleScroll);
    } else {
      // Force scrolled state on all other pages
      header.classList.add("scrolled");

      // Inject CSS overrides to completely disable animation/transitions for non-homepage templates
      const style = document.createElement("style");
      style.id = "static-header-logo-styles";
      style.innerHTML = `
        header .header-logo__image-container {
          transition: none !important;
          transform: translateY(0) !important;
          width: auto !important;
        }
        header .header-logo__image {
          transition: none !important;
          transform: none !important;
        }
      `;
      document.head.appendChild(style);
    }
  }
})();